<template>
    <div class="text-box">
        <div class="back">
            <slot name="left"></slot>
        </div>
        <div class="goon">
            <slot name="right" class="goon"></slot>
        </div>
        <div class="introduce" ref="introduce">
            <div :class="['scroll', `s${fontText}`]" :style="{width: `${fontText.length * .65}rem`, float: 'right'}"></div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['fontText'],
    data() {
        return {
        };
    }
};
</script>

<style lang="stylus" scoped>
.text-box
    position relative
    size 7.14rem 3.38rem
    background-color #ede1c2
    opacity 0.78
    .back
        position absolute
        top -1rem
        left 0
        font-size .46rem
        color #fbecc2
    .goon
        position absolute
        top -1rem
        right 0
        font-size .46rem
        color #fbecc2
    .introduce
        position absolute
        left 50%
        top 50%
        transform translate3d(-50%, -50%, 1px)
        size 6.54rem 3.04rem
        padding .12rem 0
        border solid .02rem #5d2c1f
        background-color #ede1c2
        font-size .33rem
        color #303030
        opacity 0.78
        overflow-x auto
        overflow-y hidden
        .scroll
            height 100%
            &.s1
                size 100%
                background url('/img/xj/lv4_text_1.png') center center/auto 100% no-repeat
            &.s2
                size 100%
                background url('/img/xj/lv4_text_2.png') center center/auto 100% no-repeat
</style>
